<template>
  <!--
      描述：商品设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">基本设置</div>
      <el-form-item label="商品编码文字自定义">
        <el-input v-model="form.product_no_text" type="text" style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="商品内部编码文字自定义">
        <el-input v-model="form.product_diy_no_text" type="text" style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="商品编码显示">
        <el-radio-group v-model="form.product_no_show">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品内部编码显示">
        <el-radio-group v-model="form.product_diy_no_show">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品海报显示价格">
        <el-radio-group v-model="form.product_price_show">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="商品默认图片">
        <div v-if="form.product_default_image" class="default-image-box" @click="openProductUpload">
          <div class="image-box">
            <img :src="form.product_default_image.file_path" alt="product_default_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>

      <el-form-item label="详情附加图">
        <div v-if="form.product_plus_image" class="default-image-box" @click="plusProductUpload">
          <div class="image-box">
            <img :src="form.product_plus_image" alt="product_plus_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deletePlusImg" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="plusProductUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>

      <el-form-item label="分类默认图">
        <div v-if="form.cate_default_image" class="default-image-box" @click="cateProductUpload">
          <div class="image-box">
            <img :src="form.cate_default_image" alt="cate_default_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteCateImg" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="cateProductUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>

    <div class="common-form">商品显示</div>
      <el-form-item label="下单方式" prop="is_open_cart">
        <!-- <el-switch v-model="form.is_open_cart"></el-switch> -->
        <el-radio-group v-model="form.is_open_cart">
          <el-radio :label="0">购物车+立即购买</el-radio>
          <el-radio :label="1">购物车</el-radio>
          <el-radio :label="2">立即购买</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="供应商显示">
        <el-radio-group v-model="form.supply_show">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品标签显示">
        <el-radio-group v-model="form.label_show">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品标签与标题合并显示">
        <el-radio-group v-model="form.label_in_title">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开启多规格">
        <el-radio-group v-model="form.single_spec">
          <el-radio :label="1">关闭</el-radio>
          <el-radio :label="0">开启</el-radio>
        </el-radio-group>
      </el-form-item>
     <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    <!--详情附加图片组件-->
    <Upload v-if="isPlusUpload" :config="{ total: 9 }" :isupload="isPlusUpload" @returnImgs="returnPlusImgsFunc">上传图片</Upload>
     <!--分类默认图片组件-->
    <Upload v-if="isCateUpload" :config="{ total: 9 }" :isupload="isCateUpload" @returnImgs="returnCateImgsFunc">上传图片</Upload>
  </div>

</template>

<script>
  import ProductApi from '@/api/product.js';
  import Upload from "@/components/file/Upload";
  export default {
    components: {
      Upload,
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          product_no_text: '',
          product_diy_no_text: '',
          product_no_show: 0,
          product_diy_no_show: 0,
          supply_show: 0,
          label_show: 0,
          label_in_title: 0,
          product_price_show:1,
          single_spec:0,
          product_default_image: {
            file_path: '',
          },
          is_open_cart:0,
          product_plus_image:'',
          cate_default_image:''
        },
        loading: false,
        isProductUpload: false,
        isPlusUpload:false,
        isCateUpload:false,
      };
    },
    created() {
      this.getParams()
    },
    methods: {

      getParams() {
        let self = this;
        ProductApi.settingDetail({}, true)
          .then(data => {
            if (Number(data.code) === 1) {
              self.form = data.data.vars.values
              if(self.form.is_open_cart == true){
                self.form.is_open_cart = 0;
              }else if(self.form.is_open_cart == false){
                self.form.is_open_cart = 2;
              }
            }
          })
          .catch(error => {

          });

      },
      //监听复选框选中
      handleCheckedCitiesChange(val) {},
      onSubmit() {
        let self = this;
        self.loading = true;
        let form = self.form;
        ProductApi.editSetting(form, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，交易设置成功',
              type: 'success'
            });
            self.$router.push('/product/setting/index');
          })
          .catch(error => {
            self.loading = false;
          });
      },

      openProductUpload() {
        this.isProductUpload = true;
      },
      plusProductUpload() {
        this.isPlusUpload = true;
      },
      cateProductUpload() {
        this.isCateUpload = true;
      },
      /*删除商品图片*/
      deleteImg() {
        this.form.product_default_image = {
          file_path: ''
        }
      },
      deletePlusImg() {
        this.form.product_plus_image = '';
      },
      deleteCateImg() {
        this.form.cate_default_image = '';
      },
      /*上传商品图片*/
      returnProductImgsFunc(e) {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false
              }
            });
          });
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
          this.form.product_default_image = e[0]
        }
        this.isProductUpload = false;
      },
      // 上传详情附加图
      returnPlusImgsFunc(e) {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false
              }
            });
          });
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
          this.form.product_plus_image = e[0].file_path
          // console.log(this.form.product_plus_image)
        }
        this.isPlusUpload = false;
      },
      // 上传分类默认图
      returnCateImgsFunc(e) {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false
              }
            });
          });
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
          this.form.cate_default_image = e[0].file_path
          // console.log(this.form.product_plus_image)
        }
        this.isCateUpload = false;
      },
    }

  };
</script>

<style lang="scss" scoped>
  .tips {
    color: #ccc;
  }
  .img-select {
    position: relative;
    width: 110px;
    height: 110px;
    margin-right: 10px;
    i {
      display: flex;
      line-height: 110px;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px dashed #dddddd;
      font-size: 30px;
      color: #409eff;
    }
  }
  .image-box {
    width: 110px;
    height: 110px;
    overflow: hidden;
    img {
      width: 110px;
      //height: 110px;
    }
  }
  .image-box:hover .delete-btn {
    display: block;
  }
  .default-image-box {
    position: relative;
    width: 110px;
    height: 110px;
  }
  .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/setting/index.vue